import React from 'react';
import { XIcon } from 'lucide-react';
import { painGroups } from '../data/content';
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-130" data-mp="2pe7eu3w4nl5a">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-131" data-mp="2bfzls727p3ze">
        <h2 className="mx-auto max-w-4xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-132" data-mp="2bfg48rgh4hlw">
          ¿Reconoces alguna de estas situaciones?
        </h2>

        <div className="mx-auto mt-12 grid max-w-4xl gap-10 md:grid-cols-2 md:gap-8" data-id="element-133" data-mp="21olh7kveldze">
          {painGroups.map(group => <div key={group.audience} className="flex h-full flex-col" data-id="element-134" data-mp="1sp866nrmshck">
              <h3 className="text-xl font-extrabold tracking-tight text-slate-900 md:text-2xl" data-id="element-135" data-mp="1sr2nzt7lvtcf">
                {group.audience}
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-136" data-mp="1iqinisrwusv9">
                {group.points.map(point => <li key={point} className="flex items-start gap-4 rounded-2xl bg-red-50 px-5 py-4 ring-1 ring-red-100" data-id="element-137" data-mp="1nqofka23ehdv">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-138" data-mp="oau96jaxpqap">
                      <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-139" data-mp="129k5vxtudnyj" />
                    </span>
                    <span className="font-medium leading-snug text-slate-900" data-id="element-140" data-mp="xcldpktqnr2z">{point}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-141" data-mp="5l5jp5pur22q">
          No te falta información. Te falta tenerla organizada de forma VISUAL.
        </p>
      </div>
    </section>;
}